import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types'


export const PrivateRoute = ({
    isAuthenticated,
    component: Component,
    ...rest
}) => {

    /* isAuthenticated = false;
    console.log('Bool : ', isAuthenticated) */


    return ( 
        <Route { ...rest }
        component={ (props)=> (
            ( isAuthenticated )
            ? ( <Component {...props} />)
            : ( <Redirect to='/' />)
        )}
    />  
        
     );
}

PrivateRoute.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    component: PropTypes.func.isRequired
}
 

   
